export const YouTube = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icons">
        <path
          id="Rectangle 1558"
          d="M2.70561 15.3236C3.02126 11.4798 5.96475 8.46534 9.78116 7.90871C12.9884 7.44092 16.9524 7 20.5 7C24.0921 7 28.1111 7.45205 31.3392 7.92633C35.0951 8.47814 37.9998 11.4169 38.3022 15.201C38.4186 16.6573 38.5 18.2879 38.5 20C38.5 21.7388 38.416 23.3936 38.2967 24.8671C37.9932 28.6165 35.1309 31.5381 31.4097 32.0891C28.2453 32.5577 24.2621 33 20.5 33C16.7843 33 12.8528 32.5685 9.70765 32.1064C5.92598 31.5508 3.02782 28.554 2.71127 24.7449C2.58775 23.2586 2.5 21.6293 2.5 20C2.5 18.3957 2.58508 16.7914 2.70561 15.3236Z"
          fill="url(#paint0_linear_3848_132696)"
        />
        <g id="Polygon 16" filter="url(#filter0_di_3848_132696)">
          <path
            d="M27.7664 19.1103C28.491 19.4822 28.491 20.5178 27.7664 20.8897L17.4566 26.1807C16.7911 26.5222 16 26.039 16 25.291L16 14.709C16 13.961 16.7911 13.4778 17.4566 13.8193L27.7664 19.1103Z"
            fill="url(#paint1_linear_3848_132696)"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_di_3848_132696"
          x="8"
          y="9.70703"
          width="28.3101"
          height="28.5859"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3848_132696" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3848_132696" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3848_132696" />
        </filter>
        <linearGradient
          id="paint0_linear_3848_132696"
          x1="20.5"
          y1="8"
          x2="20.5"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A7FFF" />
          <stop offset="1" stopColor="#E232FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3848_132696"
          x1="23.5"
          y1="26"
          x2="32.5"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.41" />
        </linearGradient>
      </defs>
    </svg>
  )
}
